import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'light', setTheme: () => {} });

const STORAGE_KEY = 'mnevia_theme';

function getInitialTheme() {
  // 1. Respect explicit user choice if they have toggled the theme before.
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  // 2. No stored preference → default to light, regardless of system dark-mode.
  return 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem(STORAGE_KEY, t);
  };

  // Apply data-theme attribute on <html> so CSS can target it globally
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // We intentionally do NOT listen for system-theme changes. The app defaults
  // to light; users who prefer dark can toggle it via the sidebar button, and
  // that choice is persisted. Auto-switching on OS theme flips was surprising.

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
